import Vue from 'vue';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';

interface DeliverySheetBoardState {
    filterDataLoading: boolean;
    filterDataLoaded: boolean;
    cities: any[];
  
    pipelineId: string | null;

    pipeline: any;
    statuses: any[];
    deals: any[];
  
    dataRequested: boolean;
    dataLoading: boolean;
    dataLoaded: boolean;
  
    // products: any[];
    // variants: any[];
  
    // vehicles: any[];
    // zones: any[];
    // computedZones: any[];
  
    // valid: boolean;
  
    // savingData: boolean;
}

const state: DeliverySheetBoardState = {
    filterDataLoading: false,
    filterDataLoaded: false,
    cities: [],
  
    pipelineId: null,
    
    pipeline: null,
    statuses: [],
    deals: [],
  
    dataRequested: false,
    dataLoading: false,
    dataLoaded: false,
  
    // vehicles: [],
    // zones: [],
    // computedZones: [],
  
    // valid: false,
  
    // savingData: false,
};


function getPipelineStatusesQuery(pipeId: string, _filterQ: string = '') {

  const dataQuery: any = {
    columns: {
      id: 'status.id',
      pipeline_id: 'status.pipeline_id',
      name: 'status.name',
      code: 'status.code',
      position: 'status.position',
      color: 'status.color',
      final: 'status.final',
      deals_count: {
        $count: 'dls.id'
      },
      total_cost: {
        $sum: 'dpc.total_cost'
      }
    },
    from: 's:statuses',
    from_as: 'status',
    joins: [
      {
        join: 's:deals',
        type: 'left',
        as: 'dls',
        on: {
          $and: [
            { $eq: ['dls.status_id', 'status.id'] },
            { $ilike: ['dls.name', {$: `%${_filterQ}%`}] },
          ]
        }
      },
      {
        join: {
          columns: {
            deal_id: 'dpc.deal_id',
            total_cost: { $sum: 'dpc.container_price' }
          },
          from: 's:deal_product_containers',
          from_as: 'dpc',
          groups: [
            'dpc.deal_id'
          ]
        },
        type: 'left',
        as: 'dpc',
        on: {
          $and: [
            { $eq: ['dpc.deal_id', 'dls.id'] },
            { $ilike: ['dls.name', {$: `%${_filterQ}%`}] },
          ]
        }
      },
    ],
    groups: [
      'status.id',
      'status.pipeline_id',
      'status.name',
      'status.code',
      'status.position',
      'status.color',
      'status.final'
    ],
    order: [
      {
        $asc: [
          'status.position'
        ]
      }
    ]
  };

  dataQuery.where = {
    $eq: [`status.pipeline_id`, {$: pipeId}]
  };

  return dataQuery;
}

function getDealsListQuery(statusId: string, params: any = {}) {
  params = params || {};
  // console.log('params', params)

  const $q = params._q || '';

  const dataQuery: any = {
    columns: {
      id: 'deal.id',
      name: 'deal.name',
      status_id: 'deal.status_id',
      created_at: 'deal.created_at',
      updated_at: 'deal.updated_at',
      client_name: 'cl.name',
      cost: { $sum: 'dpc.container_price' },
      sample_items: 'dpc_with_samples.sapmle_count'
      // {"$sum": {"$mul": ["dpc.container_quantity", "dpc.container_price"]}},
      // "position": "status.position",
      // "color": "status.color",
      // "final": "status.final",
    },

    from: 's:deals',
    from_as: 'deal',
    joins: [
      {
        join: `s:clients`,
        type: 'left',
        as:   `cl`,
        on: {
          $eq: [`deal.client_id`, `cl.id`]
        }
      },
      {
        join: 's:deal_product_containers',
        type: 'left',
        as:   'dpc',
        on: {
         $eq: ['dpc.deal_id', 'deal.id']
        }
      },
      {
        join: 's:statuses',
        as:   'statuses',
        on: {
         $eq: ['statuses.id', 'deal.status_id']
        }
      },
      {
        join: {
          columns: {
            deal_id: 'dpc.deal_id',
            sapmle_count: { $count: 'dpc.id' }
          },
          from: 's:deal_product_containers',
          from_as: 'dpc',
          joins: [
            {
              join: 's:product_containers',
              type: 'left',
              as:   'pc',
              on: {
                $eq: ['pc.id', 'dpc.product_container_id']
              }
            },
          ],
          groups: [
            'dpc.deal_id'
          ],
          where: {
            $or: [
              { $eq: ['dpc.is_sample', { $: true } ] },
              { $eq: ['pc.is_sample', { $: true } ] },
            ]
          }
        },
        type: 'left',
        as: 'dpc_with_samples',
        on: { $eq: ['dpc_with_samples.deal_id', 'deal.id'] }
      }
    ],
    groups: ['deal.id', 'deal.name', 'deal.status_id', 'deal.created_at', 'deal.updated_at', 'statuses.position', 'cl.id', 'cl.name', 'dpc_with_samples.deal_id', 'dpc_with_samples.sapmle_count'],
    order: [
      {$asc: ['statuses.position']},
      {$desc: ['deal.created_at']}
    ],
    where: {
      $and: [
        { $eq: [`statuses.id`, {$: statusId}] },
        { $ilike: ['deal.name', {$: `%${$q}%`}] },
      ]
    },
    page_size: 200
  };

  return dataQuery;
}

export const actions: ActionTree<DeliverySheetBoardState, RootState> = {
    // changeFilterValue({ commit, getters, dispatch, state }, {field, newValue}) {
    //     (state as any)[field] = newValue;
    //     if (state.cityId && state.deliveryDate) {
    //         dispatch('loadPipelineData', { cityId: state.cityId, deliveryDate: state.deliveryDate })
    //     }
    // },

    setFilterValue({ commit, getters, dispatch, state }, query) {

        if (query.id) {
            state.pipelineId = query.id
        }

        if (state.pipelineId) {
            dispatch('loadPipelineData', { pipelineId: state.pipelineId })
        }
    },

    loadPipelineData({ commit, getters, dispatch, state }, { pipelineId }) {
      const vm = (this as any)._vm;

      commit('LOAD_PIPELINE_DATA', { pipelineId });

      vm.$db([
          vm.$q('LOAD_PIPELINE')
            .raw('documents.get')
            .action({
              id: pipelineId
            }),
          vm.$q('LOAD_PIPELINE_STATUSES')
            .raw('documents.list')
            .action(getPipelineStatusesQuery(pipelineId)),
          // vm.$q('LOAD_DEALS')
          //   .raw('documents.list')
          //   .action(getDealsListQuery(pipelineId)),
          // (this as any).$q('LOAD_DEALS')
          //   .select()
          //   .fileds({
          //       id: `pipelines.id`,
          //       label: `pipelines.name`
          //   })
          //   .from('deals')
          //   .limit(1000),
        ]).then(((result: ServerResult) => {
            commit('PIPELINE_LOADED_SUCCESS', {
              pipeline: result.getOperation('LOAD_PIPELINE').getContent().document,
              statuses: result.getOperation('LOAD_PIPELINE_STATUSES').getContent().documents
            })
        }));
    },

    loadStatusData({ commit, getters, dispatch, state }, { status,  }) {
      const vm = (this as any)._vm;

      // commit('LOAD_PIPELINE_DATA', { pipelineId });

      vm.$db([
          vm.$q('LOAD_DEALS')
            .raw('documents.list')
            .action(getDealsListQuery(status.id)),
        ]).then(((result: ServerResult) => {
          console.log(result)
            commit('STATUS_LOADED_SUCCESS', {
              status: status,
              ...result.getOperation('LOAD_DEALS').getContent()
            })
        }));
    },

    moveDealBetweenStatus({ commit, getters, dispatch, state }, {status, newItemList}) {
      const vm = (this as any)._vm;

      const updateTarget = newItemList.filter((deal: any) => {
        return deal.status_id != status.id
      })

      const queries = updateTarget.map((targetDeal: any) => {
        return vm.$q('UPDATE_DEAL_STATUS')
          .update(targetDeal.id, { status_id: status.id })
      });

      if (queries.length > 0) {
        vm.$db(
          queries
        ).then(((result: ServerResult) => {
          console.log('result', result)
        }));
      }

      commit('MOVE_DEAL_BETWEEN_STATUS', {status, newItemList});
    },

};

export const mutations: MutationTree<DeliverySheetBoardState> = {
    LOAD_FILTER_DATA: (state) => {
        state.filterDataLoading = true;
    },

    FILTER_DATA_LOADED_SUCCESS: (state, {cities}) => {
        state.cities = cities;
        state.filterDataLoading = false;
        state.filterDataLoaded = true;
    },
    
    LOAD_PIPELINE_DATA: (state, { pipelineId }) => {
        // state.cityId = cityId;
        // state.deliveryDate = deliveryDate;
        state.dataRequested = true;
        state.dataLoading = true;
    },

    PIPELINE_LOADED_SUCCESS: (state, {pipeline, statuses}) => {
      const computedStatuses = statuses.reduce((ac: any, status: any) => {
        ac[status.id] = status;
        ac[status.id].deals = [];
        ac[status.id].meta = {};
        return ac
      }, {});

      // for(const deal of deals) {
      //   computedStatuses[deal.status_id].deals.push(deal);
      // }

      state.pipeline = pipeline
      state.statuses = Object.values(computedStatuses);
      // state.deals = deals;

      state.dataLoading = false;
      state.dataLoaded = true;
    },

    STATUS_LOADED_SUCCESS: (state, { status, documents, meta }) => {
      const statusIndex = state.statuses.findIndex((_status: any) => _status.id == status.id);
      console.log('statusIndex', statusIndex, state.statuses[statusIndex]);

      state.statuses[statusIndex].deals = documents;
      state.statuses[statusIndex].meta = meta;
    },

    MOVE_DEAL_BETWEEN_STATUS: (state, {status, newItemList}) => {
      const statuses = JSON.parse(JSON.stringify(state.statuses))
    
      const statusIndex = statuses.findIndex((_status: any) => _status.id === status.id);

      statuses[statusIndex].deals = newItemList;

      state.statuses = statuses;
    },

};

const getters: GetterTree<DeliverySheetBoardState, RootState> = {

};

export const STORE_KEY = '$_deal_pipelines';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
